import React from "react";
import T from "prop-types";
import { connect } from "react-redux";
import { Map } from "immutable";
import { get } from "lodash";
import pojo from "LIB/pojos";
import removeKey from "LIB/removeKey";
import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import { withSalesOrder } from "MODULES/SalesOrders/decorators";
import { translateProps } from "MODULES/shared/decorators";
import {
  AS_IS,
  ADMIN,
  ACCOUNTING,
  QUALITY_CONTROL,
  USER,
  ROLE
} from "MODULES/users/constants";
import { CONDITION } from "MODULES/inventories/constants";
import api from "APP_ROOT/api";
import { dateFormFormat } from "LIB/formatters/date";
import { ID } from "APP_ROOT/constants";
import { CONTAINER_FEE } from "MODULES/PurchaseOrders/constants";
import Form from "./Form";
import { fields } from "./lineItem";

export function Edit({ editing, close, lineItem, ...props }) {
  const values = pojo(lineItem.toJS()).pick(...fields);
  const part = lineItem.isEmpty() ? null : lineItem.get("part").toJS();

  const initialValues = {
    ...values,
    as_is: lineItem.get(AS_IS, false),
    exchange_sale: values.exchange_sale,
    core_expected_date: (() => {
      const shippedDate = values.shipped_at
        ? new Date(values.shipped_at)
        : new Date();
      const coreDueDays = Number.isInteger(values.core_due_days)
        ? values.core_due_days
        : 30;
      shippedDate.setDate(shippedDate.getDate() + coreDueDays); // Add the days
      return dateFormFormat(shippedDate);
    })(),
    core_due_days: Number.isInteger(values.core_due_days)
      ? values.core_due_days
      : "30",
    container_fee: get(
      values,
      CONTAINER_FEE,
      get(part, "special_container_fee", 0)
    ),
    customer_to_return_container: get(
      values,
      "customer_to_return_container",
      get(part, "special_container_req")
    ),
    condition: get(values, CONDITION)
  };
  const filteredInitialValues = props.canReleaseForShipment
    ? initialValues
    : removeKey(initialValues, "release_for_shipment");
  return (
    <Modal open={editing} close={close} dialogClass="modal-lg">
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Edit Part</h4>
      </Header>
      <Form
        {...props}
        close={close}
        editing={editing}
        lineItem={lineItem}
        showTable={false}
        selectedSeller={(lineItem.get("seller") || Map()).toJS()}
        selectedSecondSeller={(lineItem.get("second_seller") || Map()).toJS()}
        initialValues={filteredInitialValues}
      />
    </Modal>
  );
}

Edit.propTypes = {
  lineItem: T.instanceOf(Map),
  editing: T.bool.isRequired,
  close: T.func.isRequired,
  canReleaseForShipment: T.bool
};

const withProps = connect(state => ({
  canReleaseForShipment:
    state.session.getIn([USER, ROLE]) === ADMIN ||
    state.session.getIn([USER, "can_release_shipment"]),
  nonAccountingUser: ![ACCOUNTING, ADMIN].includes(
    state.session.getIn([USER, ROLE])
  ),
  nonQCUser: state.session.getIn([USER, ROLE]) !== QUALITY_CONTROL
}));

const withSubmit = translateProps(({ lineItem }) => ({
  onSubmit: data => api.salesOrders.lineItems.update(lineItem.get(ID), data)
}));

export default withSalesOrder(withSubmit(withProps(Edit)));



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Body/LineItems/Edit.jsx